import {createAction} from '@reduxjs/toolkit';
import {NavigateFunction} from 'react-router';
import {CreateBeerDTO, GetBeersDTO} from 'typescript/dto/beersDto';
import {GetBeerPubsDTO} from 'typescript/dto/GetBeerPubsDTO';
import {withPayloadType} from 'typescript/types/PayloadType';
import {StatisticDateRangeType} from 'typescript/types/StatisticDateRangeType';

const beersNamespace = 'beers';

const getBeersACS = createAction(`${beersNamespace}/getBeersACS`, withPayloadType<GetBeersDTO>());

const createBeerACS = createAction(
  `${beersNamespace}/createBeerACS`,

  withPayloadType<{dto: CreateBeerDTO; navigate?: NavigateFunction}>(),
);

const updateSingleBeerACS = createAction(
  `${beersNamespace}/updateSingleBeerACS`,
  withPayloadType<{id: string; data: CreateBeerDTO}>(),
);

const getBeerPubsACS = createAction(`${beersNamespace}/getBeerPubsACS`, withPayloadType<GetBeerPubsDTO>());
const deleteBeerACS = createAction(`${beersNamespace}/deleteBeerACS`, withPayloadType<{id: string; name: string}>());
const getBeerSocialMediaStatisticACS = createAction(
  `${beersNamespace}/getBeerSocialMediaStatisticACS`,
  withPayloadType<{dateRange: StatisticDateRangeType; id: string}>(),
);

export {getBeersACS, deleteBeerACS, getBeerPubsACS, updateSingleBeerACS, createBeerACS, getBeerSocialMediaStatisticACS};
